<template>
  <div
    class="form-group mt-5 flatpicker-group"
    :class="{ hasValue: showInput }"
  >
    <flat-pickr
      name="date"
      ref="datePicker"
      :config="dateConfig"
      @on-change="update"
      class="form-control"
      :value="value"
      v-validate="config.Validation"
      @on-open="hackIT"
      @on-close="setYear"
    ></flat-pickr>

    <label
      v-if="config.date.dateDefaultToday"
      class="form-control-placeholderDate"
    >
      <span>{{ config.Placeholder }}</span>
      <span
        class="required-star"
        v-if="config.Validation.required && config.Placeholder"
        >*</span
      >
      <small v-if="!config.Validation.required">Valgfri</small>
    </label>
    <label
      v-if="!config.date.dateDefaultToday"
      class="form-control-placeholder"
    >
      <span>{{ config.Placeholder }}</span>
      <span
        class="required-star"
        v-if="config.Validation.required && config.Placeholder"
        >*</span
      >
      <small v-if="!config.Validation.required">Valgfri</small>
    </label>
    <div @click.prevent="open()" class="datepicker_icon">
      <svg
        width="20"
        height="20"
        viewBox="0 0 20 20"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M14 2V.852c0-.47.448-.852 1-.852s1 .382 1 .852V2h4v18H0V2h4V.852C4 .382 4.448 0 5 0s1 .382 1 .852V2h8zm-3 13h4v-4h-4v4zm-9 3h16V6H2v12z"
          fill-rule="nonzero"
        />
      </svg>
    </div>
  </div>
</template>

<script>
  //
  import flatPickr from 'vue-flatpickr-component';
  import { Danish } from 'flatpickr/dist/l10n/da.js';
  export default {
    inject: {
      $validator: '$validator',
    },
    props: ['value', 'id', 'config'],
    data() {
      return {
        // Initial value
        showInput: '',
        dateConfigGlobal: {
          minDate: '',
          defaultDate: 'today',
          enableTime: false,
          wrap: true,
          disableMobile: true,
          altFormat: 'j. F Y',
          altInput: true,
          dateFormat: 'Y-m-d',
          locale: Danish, // locale for this instance only
        },
      };
    },
    computed: {
      dateConfig() {
        return { ...this.dateConfigGlobal, ...this.config.date };
      },
    },
    components: {
      flatPickr,
    },
    methods: {
      setYear(date, value, instance) {
        if (value) {
          let newD = value.split('-');
          let newW = instance.currentYear + '-' + newD[1] + '-' + newD[2];
          this.$emit('input', newW);
          this.$store.state.enrollmentDate = newW;
        }
      },
      hackIT(date, value, instance) {
        if (value) {
          let newD = value.split('-');
          instance.changeYear((instance.currentYear = Number(newD[0])));
        } else {
          instance.changeYear(instance.currentYear + 1);
          instance.changeYear(instance.currentYear - 1);
        }
      },
      update(selectedDates, dateStr) {
        // check if valid
        if (dateStr) {
          this.showInput = true;
          this.$emit('getNewData');
        } else {
          this.showInput = false;
        }
        this.$emit('input', dateStr);
        this.$store.state.enrollmentDate = dateStr;
        if (this.config.changeRange) {
          this.$refs.datePicker.fp.redraw();
          this.$emit('setChangeDate', this.config.changeRange, dateStr);
        }
        this.$store.state.enrollmentDate = dateStr;
      },
      open() {
        this.$refs.datePicker.fp.open();
      },
      GetDefaulktDateIfAny() {
        return '';
      },
    },
    mounted() {
      if (!this.value) {
        this.$validator.validate();
        this.dateConfigGlobal.minDate = this.config.date.minDate;
        if (this.config.date.dateDefaultToday) {
          this.dateConfigGlobal.defaultDate = 'today';
          this.$emit('input', this.dateConfigGlobal.defaultDate);
          this.$store.state.enrollmentDate = this.dateConfigGlobal.defaultDate;
          this.$validator.validate();
          this.$store.state.enrollmentDate = this.value;
        }
        if (this.value) {
          this.showInput = true;
        } else {
          this.showInput = false;
        }
      }
    },
    created() {
      if (this.value) {
        this.$emit('input', this.value);
      }
    },
  };
</script>
<style lang="scss" scoped>
  .fake-btn {
    position: absolute;
    left: -3000px;
    opacity: 0;
  }

  .form-control-placeholder {
    left: 30px;
  }

  button {
    width: 100%;
    position: absolute;
    height: 100%;
    z-index: 10;
  }

  .datepicker_icon {
    position: absolute;
    width: 100%;
    height: 32px;
    bottom: 0;
    z-index: 100;

    svg {
      fill: $blue80;
    }
  }
  .flatpicker-group ::v-deep .form-control {
    padding-left: 30px;
  }
</style>
